import { ANONYMOUS_USER_ID } from '../../constants/tempData/tempData.contant';
import { IUserTempData, IUserTempDataMap } from '../../interfaces/Element.interfaces';
import { browserStorage } from '../browserStorage.util';
import { formatMapToJSONString } from '../formatter/formatMapToJSONString.util';
import { getUserTempDataMapFromStorage } from '../getter/getUserTempData.util';

export interface ISetUserTempDataMapToStorageParam {
  newTempDataMap: IUserTempDataMap;
}

export const setUserTempDataMapToStorage = ({ newTempDataMap }: ISetUserTempDataMapToStorageParam): void => {
  browserStorage.setItem({
    storageType: 'localStorage',
    itemKey: 'userTempData',
    value: formatMapToJSONString(newTempDataMap),
  });
};

export interface ISetUserTempDataToMapParam {
  userId?: string;
  newTempData: IUserTempData;
}

interface ISetUserTempDataToMapReturn {
  newTempDataMap: IUserTempDataMap;
}

export const setUserTempDataToMap = ({
  userId,
  newTempData,
}: ISetUserTempDataToMapParam): ISetUserTempDataToMapReturn => {
  const { userTempDataMap } = getUserTempDataMapFromStorage();
  userTempDataMap.set(userId ?? ANONYMOUS_USER_ID, formatMapToJSONString(newTempData));
  return { newTempDataMap: userTempDataMap };
};
